// 回收宝资讯
import { getHttpInstance } from './base';

export const getArticleList = (pageSize) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(
    `${httpInstances.apiHost}/api/seo/getArticleList`
  );
};

export const getCommentList = (pageSize) => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(
    `${httpInstances.apiHost}/api/seo/getCommentList`
  );
};

export const getFriendLink = () => {
  const httpInstances = getHttpInstance();
  return httpInstances.http.post(`${httpInstances.apiHost}/api/seo/getLinks`);
};



// WEBPACK FOOTER //
// ./src/apis/zx.js